import { registerCapability } from '../../platform/capability-registry';
import { MaasImageStorageBlock } from './MaasImageStorageBlock';
import { MAAS_IMAGE_STORAGE_FIELD_KEY_LIST } from './fieldKeys';
import { resolveMaasImageStoragePaths } from './resolvePaths';
import type { MaasImageStorageBlockOptions } from './types';

registerCapability<MaasImageStorageBlockOptions>({
  key: 'maas-image-storage',
  fields: [...MAAS_IMAGE_STORAGE_FIELD_KEY_LIST],
  component: MaasImageStorageBlock,
  defaultPaths: (prefix) => resolveMaasImageStoragePaths(prefix),
  resolvePaths: (prefix) => resolveMaasImageStoragePaths(prefix),
});
